import React from "react";
import { useTheme } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import WarningIcon from "@material-ui/icons/Warning";

import ConfirmationModal from "../ConfirmationModal";
import { i18n } from "../../translate/i18n";

// Extraído de TicketsManagerTabs (doc 0446) para compartirlo con la vista simple.
const CloseAllTicketsModal = ({ open, onClose, onConfirm, canClose, option, setOption, openCount, pendingCount }) => {
  const theme = useTheme();
  return (
    <ConfirmationModal
      title={i18n.t("ticketsManager.confirmation.title")}
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmDisabled={!canClose} // ✅ DESHABILITAR SI NO HAY TICKETS
      maxWidth="sm"
      fullWidth
    >
      <Box display="flex" flexDirection="column" alignItems="center" p={2}>
        {/* ✅ ICONO DE ALERTA GRANDE */}
        <WarningIcon 
          style={{ 
            fontSize: 64, 
            color: '#ff9800', 
            marginBottom: 16 
          }} 
        />
        
        {/* ✅ TÍTULO PRINCIPAL */}
        <Typography 
          variant="h6" 
          component="h2" 
          align="center" 
          gutterBottom
          style={{ 
            fontWeight: 'bold', 
            color: theme.mode === 'dark' ? '#f87171' : '#d32f2f' 
          }}
        >
          {i18n.t("ticketsManager.confirmation.title")}
        </Typography>
        
        {/* ✅ SUBTÍTULO EXPLICATIVO */}
        <Typography 
          variant="body1" 
          align="center" 
          gutterBottom
          style={{ 
            marginBottom: 16, 
            color: theme.palette.text.secondary || theme.palette.text.primary 
          }}
        >
          {i18n.t("ticketsManager.confirmation.subtitle")}
        </Typography>
        
        {/* ✅ PREGUNTA PRINCIPAL */}
        <Typography 
          variant="body1" 
          align="center" 
          gutterBottom
          style={{ 
            fontWeight: 'bold', 
            marginBottom: 16,
            color: theme.palette.text.primary
          }}
        >
          {i18n.t("ticketsManager.confirmation.whichTicketsQuestion")}
        </Typography>

        {/* ✅ MENSAJE INFORMATIVO SI NO HAY TICKETS */}
        {!canClose && (
          <Box
            style={{
              padding: '12px 16px',
              marginBottom: 16,
              borderRadius: '8px',
              backgroundColor: theme.mode === 'dark' ? '#1e3a8a' : '#e3f2fd',
              border: `1px solid ${theme.mode === 'dark' ? '#3b82f6' : '#90caf9'}`,
              textAlign: 'center'
            }}
          >
            <Typography 
              variant="body2" 
              style={{ 
                color: theme.mode === 'dark' ? '#93c5fd' : '#1565c0',
                fontWeight: '500'
              }}
            >
              <span role="img" aria-label={i18n.t("ticketsManager.confirmation.warningEmojiAria")}>⚠️</span>{" "}
              {i18n.t("ticketsManager.confirmation.noTicketsForOption")}
            </Typography>
          </Box>
        )}
        
        {/* ✅ OPCIONES DE SELECCIÓN */}
        <FormControl component="fieldset" style={{ width: '100%', marginBottom: 16 }}>
          <RadioGroup
            value={option}
            onChange={(e) => setOption(e.target.value)}
            style={{ width: '100%' }}
          >
            <Box
              onClick={() => setOption("open")}
              style={{ 
                marginBottom: 8, 
                padding: '12px', 
                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                borderRadius: '8px',
                backgroundColor: option === "open" 
                  ? (theme.mode === 'dark' ? '#4B5563' : '#e3f2fd')
                  : (theme.mode === 'dark' ? '#374151' : '#fff'),
                transition: 'all 0.2s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                if (option !== "open") {
                  e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#4B5563' : '#f5f5f5';
                }
              }}
              onMouseLeave={(e) => {
                if (option !== "open") {
                  e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#fff';
                }
              }}
            >
              <FormControlLabel 
                value="open" 
                control={<Radio style={{ color: theme.palette.primary.main }} />} 
                label={
                  <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                    <span style={{ color: theme.palette.text.primary }}>{i18n.t("ticketsManager.confirmation.optionAttendingOpen")}</span>
                    <Badge badgeContent={openCount} color="primary" style={{ marginLeft: 16 }} />
                  </Box>
                }
                style={{ margin: 0, width: '100%' }}
              />
            </Box>
            <Box
              onClick={() => setOption("pending")}
              style={{ 
                marginBottom: 8, 
                padding: '12px', 
                border: `1px solid ${theme.mode === 'dark' ? '#4B5563' : '#e0e0e0'}`,
                borderRadius: '8px',
                backgroundColor: option === "pending" 
                  ? (theme.mode === 'dark' ? '#4B5563' : '#fce4ec')
                  : (theme.mode === 'dark' ? '#374151' : '#fff'),
                transition: 'all 0.2s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                if (option !== "pending") {
                  e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#4B5563' : '#f5f5f5';
                }
              }}
              onMouseLeave={(e) => {
                if (option !== "pending") {
                  e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#374151' : '#fff';
                }
              }}
            >
              <FormControlLabel 
                value="pending" 
                control={<Radio style={{ color: theme.palette.secondary.main }} />} 
                label={
                  <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                    <span style={{ color: theme.palette.text.primary }}>{i18n.t("ticketsManager.confirmation.optionPending")}</span>
                    <Badge badgeContent={pendingCount} color="secondary" style={{ marginLeft: 16 }} />
                  </Box>
                }
                style={{ margin: 0, width: '100%' }}
              />
            </Box>
            <Box
              onClick={() => setOption("both")}
              style={{ 
                marginBottom: 8, 
                padding: '12px', 
                border: `1px solid ${option === "both" 
                  ? (theme.mode === 'dark' ? '#dc2626' : '#ff9800')
                  : (theme.mode === 'dark' ? '#7c2d12' : '#ff9800')}`,
                borderRadius: '8px',
                backgroundColor: option === "both" 
                  ? (theme.mode === 'dark' ? '#991b1b' : '#fff3e0')
                  : (theme.mode === 'dark' ? '#78350f' : '#fff3e0'),
                transition: 'all 0.2s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                if (option !== "both") {
                  e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#991b1b' : '#ffe0b2';
                  e.currentTarget.style.borderColor = theme.mode === 'dark' ? '#dc2626' : '#ff9800';
                }
              }}
              onMouseLeave={(e) => {
                if (option !== "both") {
                  e.currentTarget.style.backgroundColor = theme.mode === 'dark' ? '#78350f' : '#fff3e0';
                  e.currentTarget.style.borderColor = theme.mode === 'dark' ? '#7c2d12' : '#ff9800';
                }
              }}
            >
              <FormControlLabel 
                value="both" 
                control={<Radio style={{ color: theme.palette.error.main }} />} 
                label={
                  <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
                    <span style={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>{i18n.t("ticketsManager.confirmation.optionBoth")}</span>
                    <Badge badgeContent={openCount + pendingCount} color="error" style={{ marginLeft: 16 }} />
                  </Box>
                }
                style={{ margin: 0, width: '100%' }}
              />
            </Box>
          </RadioGroup>
        </FormControl>
        
        {/* ✅ ADVERTENCIA FINAL */}
        <Typography 
          variant="body2" 
          align="center"
          style={{ 
            color: theme.mode === 'dark' ? '#f87171' : '#d32f2f', 
            fontWeight: 'bold',
            backgroundColor: theme.mode === 'dark' ? '#4a1f1f' : '#ffebee',
            padding: '8px 16px',
            borderRadius: '4px',
            border: `1px solid ${theme.mode === 'dark' ? '#7f1d1d' : '#ffcdd2'}`
          }}
        >
          {i18n.t("ticketsManager.confirmation.warning")}
        </Typography>
      </Box>
    </ConfirmationModal>
  );
};

export default CloseAllTicketsModal;
